import cn from 'classnames'
import { Link } from 'react-router-dom'

import { FooterProps } from './Footer.types'

export const Footer = (props: FooterProps) => {
    const { className } = props

    return (
        <footer className={cn('py-16 bg-gray-900 text-white', className)} id='contact'>
            <div className='container mx-auto px-4'>
                <ul className='flex flex-wrap justify-center gap-6 mb-12 text-gray-400'>
                    <li>
                        <a href='/#features' className='font-medium tracking-wide transition-colors duration-200 hover:text-primary'>
                            Features
                        </a>
                    </li>
                    <li>
                        <Link to='/contacts' className='font-medium tracking-wide transition-colors duration-200 hover:text-primary'>
                            Contact
                        </Link>
                    </li>
                    <li>
                        <Link to='/privacy-policy' className='font-medium tracking-wide transition-colors duration-200 hover:text-primary'>
                            Privacy Policy
                        </Link>
                    </li>
                    <li>
                        <Link to='/terms-conditions' className='font-medium tracking-wide transition-colors duration-200 hover:text-primary'>
                            Terms & Conditions
                        </Link>
                    </li>
                </ul>
                <div className='border-t border-gray-800 pt-8 text-center text-gray-400'>
                    <p>© 2025 nexly. Made in Luxembourg</p>
                </div>
            </div>
        </footer>
    )
}
